import React from 'react';
import PropTypes from 'prop-types';

import {
  RideGrid, RideButton, RideGlErrorOutline, RideGlError,
} from '@rimac-seguros/ride-system-components';

import './styles.scss';

const CustomModal = ({
  isOpen,
  children,
  fullContent,
  fullContentOnlyMobile,
  iconClose,
  classNameIcon,
  iconCloseText,
  overflow,
  closeTypeRide,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className={`contentModal ${fullContent ? 'full' : ''} ${fullContentOnlyMobile ? 'full-only-mobile' : ''} ${overflow ? 'overflow-auto' : ''}`}>
      <div className="overlay lg:!hidden" onClick={onClose} />
      <RideGrid className="gridContent">
        <div className="overlay" onClick={onClose} />
        {iconClose && (
          <div className={`iconClose ${classNameIcon}`}>
            {closeTypeRide && (
              <RideButton
                text="Cerrar"
                variant="text-secondary"
                size="large"
                glyph={<RideGlErrorOutline />}
                glyphPosition="right"
                onClick={onClose}
              />
            )}
            {!closeTypeRide && (
              <div className="content-close" onClick={onClose}>
                {iconCloseText ? (
                  <>
                    <p>{iconCloseText}</p>
                    <RideGlErrorOutline size="2x-large" fill="#A9AFD1" />
                  </>
                ) : (
                  <RideGlError size="x-large" />
                )}
              </div>
            )}
          </div>
        )}
        {children}
      </RideGrid>
    </div>
  );
};

CustomModal.defaultProps = {
  classNameIcon: '',
  closeTypeRide: false,
  fullContentOnlyMobile: false,
  fullContent: false,
};

CustomModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.element.isRequired,
  fullContentOnlyMobile: PropTypes.bool,
  fullContent: PropTypes.bool,
  iconClose: PropTypes.bool.isRequired,
  classNameIcon: PropTypes.string,
  iconCloseText: PropTypes.string.isRequired,
  closeTypeRide: PropTypes.bool,
  overflow: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CustomModal;
